import clsx from 'clsx';

import { useTranslate } from '@hd/i18n/useTranslate';
import HdOnlineLed from '@hd/ui-kit/hd-online-led/HdOnlineLed';

function ContactTableCell({
  contactName,
  contactId,
  contactEmail,
  contactPhoneNumber,
  contactIsCompanyMember,
  isOnline,
  onClick,
}: {
  contactId: number;
  contactName: string;
  contactEmail: string;
  contactPhoneNumber: string;
  contactIsCompanyMember: boolean;
  isOnline: boolean;
  onClick?: (contactId: number) => void;
}) {
  const t = useTranslate();
  return (
    <div className="flex items-start">
      <HdOnlineLed className="mt-1" online={isOnline}></HdOnlineLed>
      <div className="ml-1">
        <div className="flex align-center">
          <span
            className="mr-1 font-bold text-accent cursor-pointer"
            onClick={
              onClick
                ? (e) => {
                    e.stopPropagation();
                    onClick(contactId);
                  }
                : undefined
            }
          >
            {contactName}
          </span>
          {contactIsCompanyMember && (
            <span className={clsx("text-white bg-primary px-1 text-xs")}>
              {t("common.customer")}
            </span>
          )}
        </div>
        <div
          className="font-bold text-accent cursor-pointer"
          onClick={
            onClick
              ? (e) => {
                  e.stopPropagation();
                  onClick(contactId);
                }
              : undefined
          }
        >
          {contactEmail}
        </div>
        <div>
          {t("common.tel")}: {contactPhoneNumber}
        </div>
      </div>
    </div>
  );
}

export default ContactTableCell;
